var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import * as PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { get, cloneDeep } from "lodash";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import AppContainer from "@irati/ui/src/AppContainer";
import vitally from "@irati-web/platform/src/utils/vitally";
import tracking, { homepageTracking } from "@irati-tracking/platform";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import authentication from "@irati/auth";
import Button from "@irati/ui/src/Button";
import { getActiveProducts, getInactiveProducts, shouldShowHomepage } from "@irati/products/utils/products";
import { getExternalTenantMetadata, updateTenantMetadata } from "@irati/tenant-metadata/services/TenantMetadata";
import { tempWidget } from "@irati/tenant-metadata/enums";
import shouldShowUpSaleScreens from "@irati/products/utils/shouldShowUpSaleScreens";
import Flex from "@irati/ui/src/Flex";
import HomepageTiles, { EditPanel } from "../components/HomepageTiles";
import { getTileDimensions } from "../components/HomepageTiles/helpers";
import { Title } from "../styled";
import TenantProducts from "../components/TenantProducts";
import PerkboxWidgets from "../components/PerkboxWidgets";
import TenantSetupReminder from "../components/TenantSetupReminder";
// TODO will be removed in homepage v2
var backgroundUrl = "https://res.cloudinary.com/perkbox/image/upload/v1578935744/8f4a95b5-3f18-464c-a549-f4b5786804fb.png";
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            active: [],
            inactive: [],
            widgets: [],
            layout: [],
            editMode: false,
            editingTile: null,
            tempLayout: null,
            tenantMetadata: null,
            hasAdminSetTiles: true,
            hasHomepageTiles: !!authentication.apps("platform.homepageTiles.read")
        };
        _this.initProductCards = function () {
            var showUpSaleScreens = shouldShowUpSaleScreens();
            var active = getActiveProducts();
            var inactive = showUpSaleScreens ? getInactiveProducts() : [];
            _this.setState({ active: active, inactive: inactive });
            // Getting array of product names for tracking
            var availableProductNames = active.map(function (product) { return product.product; });
            var additionalProductNames = inactive.map(function (product) { return product.product; });
            tracking.view("home_page", { availableProductNames: availableProductNames, additionalProductNames: additionalProductNames });
        };
        _this.initFeed = function () {
            var tenantId = _this.props.auth.business.uuid;
            getExternalTenantMetadata(tenantId).then(_this.setWidgets);
            getExternalTenantMetadata(tenantId, { fetchPolicy: "network-only" }).then(_this.setWidgets);
        };
        _this.setWidgets = function (tenantMetadata) {
            var hasAdminSetTiles = tenantMetadata.homepage && tenantMetadata.homepage.widgets.length;
            var widgets = hasAdminSetTiles ? tenantMetadata.homepage.widgets : [tempWidget];
            var gridLayout = _this.getDesktopGridLayout(widgets);
            var gridWidgets = _this.getDesktopWidgets(widgets);
            _this.setState({
                layout: gridLayout,
                widgets: gridWidgets,
                tenantMetadata: tenantMetadata,
                hasAdminSetTiles: hasAdminSetTiles
            });
        };
        _this.getDesktopWidgets = function (widgets) {
            return widgets
                .filter(function (widget) { return widget; })
                .map(function (widget) {
                var _a = widget[widget.type], image = _a.image, link = _a.link, header = _a.header, body = _a.body, openLinkInNewTab = _a.openLinkInNewTab, videoUrl = _a.videoUrl;
                return {
                    i: widget.id,
                    type: widget.type,
                    image: image,
                    link: link,
                    header: header,
                    body: body,
                    openLinkInNewTab: openLinkInNewTab,
                    videoUrl: videoUrl
                };
            });
        };
        _this.getDesktopGridLayout = function (widgets) {
            var staticTile = { isDraggable: false, isResizable: false };
            return widgets
                .filter(function (widget) { return widget; })
                .map(function (widget) { return (__assign({ i: widget.id, x: widget.layouts.desktop.xOffset, y: widget.layouts.desktop.yOffset, h: widget.layouts.desktop.height, w: widget.layouts.desktop.width }, staticTile)); });
        };
        _this.saveTiles = function (layout, widgets) {
            var tenantMetadata = _this.state.tenantMetadata;
            var newWidgets = widgets.map(function (widget) {
                var _a;
                var widgetLayout = layout.find(function (singleLayout) { return singleLayout.i === widget.i; });
                if (!widgetLayout) {
                    return null;
                }
                delete widgetLayout.i;
                var i = widget.i, type = widget.type, newWidget = __rest(widget, ["i", "type"]);
                var newLayout = {
                    xOffset: widgetLayout.x,
                    yOffset: widgetLayout.y,
                    height: widgetLayout.h,
                    width: widgetLayout.w
                };
                return _a = {
                        id: i,
                        type: type
                    },
                    _a[type] = newWidget,
                    _a.layouts = {
                        desktop: newLayout,
                        mobile: newLayout
                    },
                    _a;
            });
            var data = __assign(__assign({}, tenantMetadata), { uuid: _this.props.auth.business.uuid, homepage: {
                    isEnabled: true,
                    widgets: newWidgets
                } });
            updateTenantMetadata(data, {}).then(function () {
                /* no-op */
            });
        };
        _this.editModeToggle = function () {
            var _a = _this.state, layout = _a.layout, widgets = _a.widgets, editMode = _a.editMode;
            var newLayout = layout.map(function (tile) { return (__assign(__assign({}, tile), { isDraggable: !editMode })); });
            if (editMode) {
                _this.saveTiles(layout, widgets);
                homepageTracking.publish();
            }
            else {
                homepageTracking.startEdit();
            }
            _this.setState({ layout: newLayout, editMode: !editMode });
        };
        _this.createTile = function (type) {
            var newWidget = {
                i: new Date().getTime().toString(),
                type: type
            };
            homepageTracking.startAddTile(type);
            _this.setState({ editingTile: newWidget });
        };
        _this.editTile = function (widget) {
            var layout = _this.state.layout;
            var tileLayout = layout.find(function (elem) { return elem.i === widget.i; });
            // Create a temporary layout to display just the tile we're editing at x:0,y:0 position
            _this.setState({
                editingTile: widget,
                tempLayout: layout,
                layout: [__assign(__assign({}, tileLayout), { x: 0, y: 0 })]
            });
        };
        _this.cancelEdit = function () {
            var _a = _this.state, tempLayout = _a.tempLayout, editingTile = _a.editingTile;
            // Restore initial layout
            _this.setState({
                editingTile: null,
                layout: tempLayout,
                tempLayout: null
            });
            homepageTracking.cancelEditTile(editingTile);
        };
        _this.cancelCreate = function () {
            _this.setState({
                editingTile: null
            });
            homepageTracking.cancelAddTile();
        };
        _this.handleOnGridChange = function (layout) {
            var editingTile = _this.state.editingTile;
            if (!editingTile) {
                _this.setState({ layout: layout });
            }
        };
        _this.addTileToGrid = function (newWidget, shape) {
            var _a = _this.state, widgets = _a.widgets, layout = _a.layout;
            layout.map(function (widgetLayout) {
                widgetLayout.y++;
            });
            var newWidgetLayout = __assign({ i: newWidget.i, x: 0, y: 0, isResizable: false }, getTileDimensions(shape));
            // Remove temp widget if it exists, and add new tile to widgets state
            var filteredWidgets = widgets.filter(function (widget) { return widget.i !== "temp"; });
            var newWidgets = filteredWidgets.concat(newWidget);
            var newLayout = layout.concat(newWidgetLayout);
            _this.setState({
                editingTile: null,
                widgets: newWidgets,
                layout: newLayout
            });
            homepageTracking.completeAddTile(newWidget);
        };
        _this.editTileOnGrid = function (editedWidget) {
            var _a = _this.state, widgets = _a.widgets, tempLayout = _a.tempLayout;
            var editedWidgets = cloneDeep(widgets);
            var oldWidgetIndex = widgets.findIndex(function (elem) { return elem.i === editedWidget.i; });
            editedWidgets[oldWidgetIndex] = editedWidget;
            _this.setState({
                editingTile: null,
                widgets: editedWidgets,
                layout: tempLayout,
                tempLayout: null
            });
            homepageTracking.completeEditTile(editedWidget);
        };
        _this.removeTileFromGrid = function (widgetId) {
            var _a = _this.state, widgets = _a.widgets, layout = _a.layout;
            // Get removed tile object for tracking
            var removedTile = widgets.find(function (elem) { return elem.i === widgetId; });
            var newWidgets = widgets.filter(function (elem) { return elem.i !== widgetId; });
            var newLayout = layout.filter(function (elem) { return elem.i !== widgetId; });
            _this.setState({
                widgets: newWidgets,
                layout: newLayout
            });
            homepageTracking.completeRemoveTile(removedTile);
        };
        return _this;
    }
    Home.prototype.componentDidMount = function () {
        var hasHomepageTiles = this.state.hasHomepageTiles;
        var formatMessage = this.props.formatMessage;
        this.initProductCards();
        vitally.showSurvey(formatMessage);
        if (hasHomepageTiles) {
            this.initFeed();
        }
    };
    Home.prototype.render = function () {
        var _a = this.props, auth = _a.auth, isMobile = _a.isMobile, isTablet = _a.isTablet;
        var tenant = auth.business;
        var _b = this.state, active = _b.active, inactive = _b.inactive, layout = _b.layout, widgets = _b.widgets, editMode = _b.editMode, editingTile = _b.editingTile, tempLayout = _b.tempLayout, hasHomepageTiles = _b.hasHomepageTiles, hasAdminSetTiles = _b.hasAdminSetTiles, tenantMetadata = _b.tenantMetadata;
        var tiles = get(tenantMetadata, "homepage.widgets");
        var canEditHomepageTiles = !!authentication.apps("platform.homepageTiles.update");
        var showTiles = hasHomepageTiles && (hasAdminSetTiles || canEditHomepageTiles);
        var hasPerks = !!authentication.apps("perks");
        if (!shouldShowHomepage() && (active === null || active === void 0 ? void 0 : active.length)) {
            var onlyActiveProduct = active[0];
            return React.createElement(Redirect, { to: onlyActiveProduct.product.toLowerCase() });
        }
        // TODO will be removed in homepage v2
        var bgStyle = showTiles ? null : "url(\"" + backgroundUrl + "\") 0 0 / " + (isMobile ? "300%" : "100%") + " #F7F7F8";
        var perkboxWidgets = React.createElement(PerkboxWidgets, { tenant: tenant, canEdit: canEditHomepageTiles, hasPerks: hasPerks });
        var renderedWidgets = (editingTile && tempLayout && [editingTile]) || widgets;
        var titleCopy = showTiles && editMode ? "home.feed.editMode.heading" : "home.products.active.title";
        var buttonCopy = editMode ? "home.feed.saveButton.label" : "home.feed.editButton.label";
        return (React.createElement(AppContainer, { mainBackground: bgStyle },
            React.createElement(Grid, null,
                isMobile && React.createElement(TenantSetupReminder, null),
                React.createElement(Row, null,
                    React.createElement(Col, { md: 9 },
                        React.createElement(Title, null,
                            React.createElement(FormattedMessage, { id: titleCopy }))),
                    showTiles && canEditHomepageTiles && !isTablet && (React.createElement(Col, { md: 3 },
                        React.createElement(Flex, { justifyContent: "flex-end", marginTop: 2 },
                            React.createElement(Button, { primary: true, onClick: this.editModeToggle },
                                React.createElement(FormattedMessage, { id: buttonCopy })))))),
                React.createElement(Row, null,
                    React.createElement(Col, { md: showTiles ? 5 : 6 },
                        editMode ? (React.createElement(EditPanel, { createTile: this.createTile, cancelEdit: this.cancelEdit, cancelCreate: this.cancelCreate, addTileToGrid: this.addTileToGrid, editTileOnGrid: this.editTileOnGrid, tempLayout: tempLayout, editingTile: editingTile })) : (React.createElement(TenantProducts, { active: active, inactive: inactive })),
                        showTiles && !editMode && !isMobile && perkboxWidgets),
                    React.createElement(Col, { md: showTiles ? 7 : 6 },
                        showTiles ? (React.createElement(HomepageTiles, { layout: layout, widgets: renderedWidgets, tiles: tiles, isMobile: isMobile, editMode: editMode, editingTileActive: !!editingTile, removeTileFromGrid: this.removeTileFromGrid, editTile: this.editTile, handleOnGridChange: this.handleOnGridChange })) : (perkboxWidgets),
                        showTiles && isMobile && perkboxWidgets)))));
    };
    Home.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return Home;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isMobile: mq.lessThan.medium,
        isTablet: mq.lessThan.large
    };
};
export default injectIntl(connect(mapStateToProps)(withAuth(Home)));
